export default __webpack_public_path__ + "static/media/euro.e40a3ead.svg";